<template>
  <div class="Inventory__Count" v-if="getInventoryDataInfo() > 0">
    <div class="stock-icon">
      <span class="material-icons done-all-icon">done</span>
    </div>
    <span>{{ getInventoryDataInfo() }} In Stock</span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  components: {},
  methods: {
    getInventoryDataInfo() {
      const inventoryInfo = this.getInventoryData;
      let inventoryTotal = 0;
      if (this.getInventoryStatusCode == 0) return 0;
      if (inventoryInfo && inventoryInfo.AvailableInventoryList) {
        inventoryInfo.AvailableInventoryList.forEach(element => {
          inventoryTotal = inventoryTotal + element.CommittedQty;
        });
      }
      return inventoryTotal;
    }
  },
  computed: {
    ...mapGetters("inventory", ["getInventoryData", "getInventoryStatusCode"])
  }
};
</script>

<style lang="scss" scoped>
.Inventory {
  &__Count {
    display: flex;
    width: 100%;
    font-family: $body;
    font-size: 16px;
    font-weight: bold;
    color: $teritiary;
    margin-bottom: 16px;
    margin-top: 16px;
    height: 24px;
    letter-spacing: 0.2px;
    line-height: 24px;
    .stock-icon {
      .material-icons {
        font-size: 24px;
        color: $teritiary;
        margin: 10px 5px 0 0;
      }
    }
  }
}
</style>
